export const ITEM_UNIT_MAP = {
  "Cement (50 kg Bag)": "Bag",
  "Cement (25 kg Bag)": "Bag",
  "Sand (M-sand)": "CFT",
  "Sand (River sand)": "CFT",
  "Blue Metal (Aggregate)": "CFT",
  "Bricks": "Nos",
  "Hollow Blocks": "Nos",
  "Fly Ash Bricks": "Nos",
  "TMT Steel Rod": "kg",
  "Binding Wire": "kg",
  "Structural Steel": "kg",
  "PVC Pipe": "Feet",
  "CPVC Pipe": "Feet",
  "Pipe Fittings": "Nos",
  "Water Tank": "Nos",
  "Electrical Wire": "Meter",
  "Switches": "Nos",
  "Switch Board": "Nos",
  "LED Light": "Nos",
  "MCB / DB Box": "Nos",
  "Paint": "Liters",
  "Putty": "kg",
  "Tiles": "sq.ft",
  "Granite": "sq.ft",
  "Marble": "sq.ft",
  "Doors": "Nos",
  "Windows": "Nos",
  "Plywood": "Sheets",
  "Laminates": "Sheets",
  "Concrete (RMC)": "m³",
  "Bitumen": "kg",
  "Glass": "sq.ft",
  "Aluminum Sections": "kg",
};

export const MATERIAL_CATEGORIES = [
  {
    category: "Building Materials",
    items: [
      "Cement (50 kg Bag)",
      "Cement (25 kg Bag)",
      "Sand (M-sand)",
      "Sand (River sand)",
      "Blue Metal (Aggregate)",
      "Bricks",
      "Hollow Blocks",
      "Fly Ash Bricks",
      "Concrete (RMC)",
      "Bitumen"
    ]
  },
  {
    category: "Steel & Structural",
    items: [
      "TMT Steel Rod",
      "Binding Wire",
      "Structural Steel"
    ]
  },
  {
    category: "Plumbing",
    items: [
      "PVC Pipe",
      "CPVC Pipe",
      "Pipe Fittings",
      "Water Tank"
    ]
  },
  {
    category: "Electrical",
    items: [
      "Electrical Wire",
      "Switches",
      "Switch Board",
      "LED Light",
      "MCB / DB Box"
    ]
  },
  {
    category: "Finishing",
    items: [
      "Paint",
      "Putty",
      "Tiles",
      "Granite",
      "Marble",
      "Glass"
    ]
  },
  {
    category: "Carpentry & Fixtures",
    items: [
      "Doors",
      "Windows",
      "Plywood",
      "Laminates",
      "Aluminum Sections"
    ]
  }
];
